import { render } from "./RecenciaCompra.vue?vue&type=template&id=51dbecdc"
import script from "./RecenciaCompra.vue?vue&type=script&lang=js"
export * from "./RecenciaCompra.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__